import React, { ReactElement, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/firestore';
import IssueCard from './IssueCard';
import moment from 'moment';
import Loader from 'react-loader-spinner';
import Navbar from './Navbar';
import FadeIn from 'react-fade-in';
import { toRoman } from 'roman-numerals';

export interface Issue {
    name: string;
    number: number;
    published: firebase.firestore.Timestamp;
    url: string;
    id: string;
    views: number;
    hidden?: boolean;
}

export default function ViewIssues(): ReactElement {
    const [issues, setIssues] = useState<Issue[] | null>(null);
    const history = useHistory();
    useEffect(() => {
        firebase
            .firestore()
            .collection('issues')
            .get()
            .then((snapshot) => {
                setIssues(
                    (
                        snapshot
                            .docs
                            .map(e => ({
                                    ...e.data(),
                                    id: e.id,
                                })
                            ) as Issue[]
                    )
                        .sort((a, b) => b.published.toMillis() - a.published.toMillis())
                        .filter(e => e.hidden !== true)
                );
            })
            .catch(() => {
                history.push('/');
            });
    }, []);

    return (
        <div className='view-issues'>
            <Navbar />
            {
                issues ? (
                    <>
                        <FadeIn className='latest-header'>
                            <h1>
                                Latest issue:&nbsp;
                                <strong>
                                    {
                                        issues[0].name
                                    }
                                </strong>
                            </h1>
                            <p>
                                <span className='numeral'>
                                    TABULA
                                </span>
                                &nbsp;Issue&nbsp;
                                <span className='numeral'>
                                    {
                                        toRoman(
                                            issues[0].number
                                        )
                                    }
                                </span>
                                &nbsp;was released&nbsp;
                                {
                                    moment(issues[0].published.toMillis())
                                        .format('Do MMM YYYY')
                                }
                                .&nbsp;
                                <Link to={`/view/${issues[0].id}`} className='link'>
                                    Read the latest issue of&nbsp;
                                    <span className='numeral'>
                                        TABULA
                                    </span>
                                    &nbsp;here.
                                </Link>
                            </p>
                            <Link to={`/view/${issues[0].id}`} className='button'>
                                Read issue&nbsp;
                                <span className='numeral'>
                                    {
                                        toRoman(
                                            issues[0].number
                                        )
                                    }
                                </span>
                            </Link>
                        </FadeIn>
                        <h1 className='title'>
                            Recent issues
                        </h1>
                        <FadeIn>
                            <div className='recent-issues'>
                                {
                                    issues.map(e => (
                                        <IssueCard key={e.published.toMillis()} issue={e} />
                                    ))
                                }
                            </div>
                        </FadeIn>
                    </>
                ) : (
                    <div className='loader'>
                        <Loader
                            type='Oval'
                            color='#cacaca'
                        />
                    </div>
                )
            }
        </div>
    );
}
